export const aidAudio = [
    {
        id: 'aid_speech301-01',
        path: './audio/debate/aid/aid_speech301-01.mp3',
    },
    {
        id: 'aid_speech301-02',
        path: './audio/debate/aid/aid_speech301-02.mp3',
    },
    {
        id: 'aid_speech301-03',
        path: './audio/debate/aid/aid_speech301-03.mp3',
    },
    {
        id: 'aid_speech301-04',
        path: './audio/debate/aid/aid_speech301-04.mp3',
    },
    {
        id: 'aid_speech301-05',
        path: './audio/debate/aid/aid_speech301-05.mp3',
    },
    {
        id: 'aid_speech301-06',
        path: './audio/debate/aid/aid_speech301-06.mp3',
    },
    {
        id: 'aid_speech301-07',
        path: './audio/debate/aid/aid_speech301-07.mp3',
    },
    {
        id: 'aid_speech301-08',
        path: './audio/debate/aid/aid_speech301-08.mp3',
    },
    {
        id: 'aid_speech301-09',
        path: './audio/debate/aid/aid_speech301-09.mp3',
    },
    {
        id: 'aid_speech301-10',
        path: './audio/debate/aid/aid_speech301-10.mp3',
    },
    {
        id: 'aid_speech301-11',
        path: './audio/debate/aid/aid_speech301-11.mp3',
    },
    {
        id: 'aid_speech301-12',
        path: './audio/debate/aid/aid_speech301-12.mp3',
    },
    {
        id: 'aid_speech301-13',
        path: './audio/debate/aid/aid_speech301-13.mp3',
    },
    {
        id: 'aid_speech301-14',
        path: './audio/debate/aid/aid_speech301-14.mp3',
    },
    {
        id: 'aid_speech301-15',
        path: './audio/debate/aid/aid_speech301-15.mp3',
    },
    {
        id: 'aid_speech301-16',
        path: './audio/debate/aid/aid_speech301-16.mp3',
    },
    {
        id: 'aid_speech301-17',
        path: './audio/debate/aid/aid_speech301-17.mp3',
    },
    {
        id: 'aid_speech301-18',
        path: './audio/debate/aid/aid_speech301-18.mp3',
    },
    {
        id: 'aid_speech301-19',
        path: './audio/debate/aid/aid_speech301-19.mp3',
    },
    {
        id: 'aid_speech301-20',
        path: './audio/debate/aid/aid_speech301-20.mp3',
    },
    {
        id: 'aid_speech301-21',
        path: './audio/debate/aid/aid_speech301-21.mp3',
    },
    {
        id: 'aid_speech301-22',
        path: './audio/debate/aid/aid_speech301-22.mp3',
    },
    {
        id: 'aid_speech301-23',
        path: './audio/debate/aid/aid_speech301-23.mp3',
    },
    {
        id: 'aid_speech301-24',
        path: './audio/debate/aid/aid_speech301-24.mp3',
    },
    {
        id: 'aid_speech301-25',
        path: './audio/debate/aid/aid_speech301-25.mp3',
    },
    {
        id: 'aid_speech301-26',
        path: './audio/debate/aid/aid_speech301-26.mp3',
    },
    {
        id: 'aid_speech301-27',
        path: './audio/debate/aid/aid_speech301-27.mp3',
    },
    {
        id: 'aid_speech301-28',
        path: './audio/debate/aid/aid_speech301-28.mp3',
    },
];

export const climateAudio = [
    {
        id: 'climate_speech101-01',
        path: './audio/debate/climate/climate_speech101-01.mp3',
    },
    {
        id: 'climate_speech101-02',
        path: './audio/debate/climate/climate_speech101-02.mp3',
    },
    {
        id: 'climate_speech101-03',
        path: './audio/debate/climate/climate_speech101-03.mp3',
    },
    {
        id: 'climate_speech101-04',
        path: './audio/debate/climate/climate_speech101-04.mp3',
    },
    {
        id: 'climate_speech101-05',
        path: './audio/debate/climate/climate_speech101-05.mp3',
    },
    {
        id: 'climate_speech101-06',
        path: './audio/debate/climate/climate_speech101-06.mp3',
    },
    {
        id: 'climate_speech101-07',
        path: './audio/debate/climate/climate_speech101-07.mp3',
    },
    {
        id: 'climate_speech101-08',
        path: './audio/debate/climate/climate_speech101-08.mp3',
    },
    {
        id: 'climate_speech101-09',
        path: './audio/debate/climate/climate_speech101-09.mp3',
    },
    {
        id: 'climate_speech101-10',
        path: './audio/debate/climate/climate_speech101-10.mp3',
    },
    {
        id: 'climate_speech101-11',
        path: './audio/debate/climate/climate_speech101-11.mp3',
    },
    {
        id: 'climate_speech101-12',
        path: './audio/debate/climate/climate_speech101-12.mp3',
    },
    {
        id: 'climate_speech101-13',
        path: './audio/debate/climate/climate_speech101-13.mp3',
    },
    {
        id: 'climate_speech101-14',
        path: './audio/debate/climate/climate_speech101-14.mp3',
    },
    {
        id: 'climate_speech101-15',
        path: './audio/debate/climate/climate_speech101-15.mp3',
    },
    {
        id: 'climate_speech101-16',
        path: './audio/debate/climate/climate_speech101-16.mp3',
    },
    {
        id: 'climate_speech101-17',
        path: './audio/debate/climate/climate_speech101-17.mp3',
    },
    {
        id: 'climate_speech101-18',
        path: './audio/debate/climate/climate_speech101-18.mp3',
    },
    {
        id: 'climate_speech101-19',
        path: './audio/debate/climate/climate_speech101-19.mp3',
    },
    {
        id: 'climate_speech101-20',
        path: './audio/debate/climate/climate_speech101-20.mp3',
    },
    {
        id: 'climate_speech101-21',
        path: './audio/debate/climate/climate_speech101-21.mp3',
    },
    {
        id: 'climate_speech101-22',
        path: './audio/debate/climate/climate_speech101-22.mp3',
    },
    {
        id: 'climate_speech101-23',
        path: './audio/debate/climate/climate_speech101-23.mp3',
    },
    {
        id: 'climate_speech101-24',
        path: './audio/debate/climate/climate_speech101-24.mp3',
    },
    {
        id: 'climate_speech101-25',
        path: './audio/debate/climate/climate_speech101-25.mp3',
    },
    {
        id: 'climate_speech101-26',
        path: './audio/debate/climate/climate_speech101-26.mp3',
    },
];

export const fieldsAudio = [
    {
        id: 'fields_speech200-01',
        path: './audio/debate/fields/fields_speech200-01.mp3',
    },
    {
        id: 'fields_speech200-02',
        path: './audio/debate/fields/fields_speech200-02.mp3',
    },
    {
        id: 'fields_speech200-03',
        path: './audio/debate/fields/fields_speech200-03.mp3',
    },
    {
        id: 'fields_speech200-04',
        path: './audio/debate/fields/fields_speech200-04.mp3',
    },
    {
        id: 'fields_speech200-05',
        path: './audio/debate/fields/fields_speech200-05.mp3',
    },
    {
        id: 'fields_speech200-06',
        path: './audio/debate/fields/fields_speech200-06.mp3',
    },
    {
        id: 'fields_speech200-07',
        path: './audio/debate/fields/fields_speech200-07.mp3',
    },
    {
        id: 'fields_speech200-08',
        path: './audio/debate/fields/fields_speech200-08.mp3',
    },
    {
        id: 'fields_speech200-09',
        path: './audio/debate/fields/fields_speech200-09.mp3',
    },
    {
        id: 'fields_speech200-10',
        path: './audio/debate/fields/fields_speech200-10.mp3',
    },
    {
        id: 'fields_speech200-11',
        path: './audio/debate/fields/fields_speech200-11.mp3',
    },
    {
        id: 'fields_speech200-12',
        path: './audio/debate/fields/fields_speech200-12.mp3',
    },
    {
        id: 'fields_speech200-13',
        path: './audio/debate/fields/fields_speech200-13.mp3',
    },
];

export const fuelAudio = [
    {
        id: 'fuel_speech201-01',
        path: './audio/debate/fuel/fuel_speech201-01.mp3',
    },
    {
        id: 'fuel_speech201-02',
        path: './audio/debate/fuel/fuel_speech201-02.mp3',
    },
    {
        id: 'fuel_speech201-03',
        path: './audio/debate/fuel/fuel_speech201-03.mp3',
    },
    {
        id: 'fuel_speech201-04',
        path: './audio/debate/fuel/fuel_speech201-04.mp3',
    },
    {
        id: 'fuel_speech201-05',
        path: './audio/debate/fuel/fuel_speech201-05.mp3',
    },
    {
        id: 'fuel_speech201-06',
        path: './audio/debate/fuel/fuel_speech201-06.mp3',
    },
    {
        id: 'fuel_speech201-07',
        path: './audio/debate/fuel/fuel_speech201-07.mp3',
    },
    {
        id: 'fuel_speech201-08',
        path: './audio/debate/fuel/fuel_speech201-08.mp3',
    },
    {
        id: 'fuel_speech201-09',
        path: './audio/debate/fuel/fuel_speech201-09.mp3',
    },
    {
        id: 'fuel_speech201-10',
        path: './audio/debate/fuel/fuel_speech201-10.mp3',
    },
    {
        id: 'fuel_speech201-11',
        path: './audio/debate/fuel/fuel_speech201-11.mp3',
    },
    {
        id: 'fuel_speech201-12',
        path: './audio/debate/fuel/fuel_speech201-12.mp3',
    },
    {
        id: 'fuel_speech201-13',
        path: './audio/debate/fuel/fuel_speech201-13.mp3',
    },
    {
        id: 'fuel_speech201-14',
        path: './audio/debate/fuel/fuel_speech201-14.mp3',
    },
    {
        id: 'fuel_speech201-15',
        path: './audio/debate/fuel/fuel_speech201-15.mp3',
    },
    {
        id: 'fuel_speech201-16',
        path: './audio/debate/fuel/fuel_speech201-16.mp3',
    },
    {
        id: 'fuel_speech201-17',
        path: './audio/debate/fuel/fuel_speech201-17.mp3',
    },
    {
        id: 'fuel_speech201-18',
        path: './audio/debate/fuel/fuel_speech201-18.mp3',
    },
    {
        id: 'fuel_speech201-19',
        path: './audio/debate/fuel/fuel_speech201-19.mp3',
    },
    {
        id: 'fuel_speech201-20',
        path: './audio/debate/fuel/fuel_speech201-20.mp3',
    },
    {
        id: 'fuel_speech201-21',
        path: './audio/debate/fuel/fuel_speech201-21.mp3',
    },
    {
        id: 'fuel_speech201-22',
        path: './audio/debate/fuel/fuel_speech201-22.mp3',
    },
    {
        id: 'fuel_speech201-23',
        path: './audio/debate/fuel/fuel_speech201-23.mp3',
    },
    {
        id: 'fuel_speech201-24',
        path: './audio/debate/fuel/fuel_speech201-24.mp3',
    },
    {
        id: 'fuel_speech201-25',
        path: './audio/debate/fuel/fuel_speech201-25.mp3',
    },
    {
        id: 'fuel_speech201-26',
        path: './audio/debate/fuel/fuel_speech201-26.mp3',
    },
    {
        id: 'fuel_speech201-27',
        path: './audio/debate/fuel/fuel_speech201-27.mp3',
    },
    {
        id: 'fuel_speech201-28',
        path: './audio/debate/fuel/fuel_speech201-28.mp3',
    },
    {
        id: 'fuel_speech201-29',
        path: './audio/debate/fuel/fuel_speech201-29.mp3',
    },
    {
        id: 'fuel_speech201-30',
        path: './audio/debate/fuel/fuel_speech201-30.mp3',
    },
];

export const genericAudio = [
    {
        id: 'generic_speech000-01',
        path: './audio/debate/generic/generic_speech000-01.mp3',
    },
    {
        id: 'generic_speech000-02',
        path: './audio/debate/generic/generic_speech000-02.mp3',
    },
    {
        id: 'generic_speech000-03',
        path: './audio/debate/generic/generic_speech000-03.mp3',
    },
];

export const homeworkAudio = [
    {
        id: 'hwork_speech102-01',
        path: './audio/debate/hwork/hwork_speech102-01.mp3',
    },
    {
        id: 'hwork_speech102-02',
        path: './audio/debate/hwork/hwork_speech102-02.mp3',
    },
    {
        id: 'hwork_speech102-03',
        path: './audio/debate/hwork/hwork_speech102-03.mp3',
    },
    {
        id: 'hwork_speech102-04',
        path: './audio/debate/hwork/hwork_speech102-04.mp3',
    },
    {
        id: 'hwork_speech102-05',
        path: './audio/debate/hwork/hwork_speech102-05.mp3',
    },
    {
        id: 'hwork_speech102-06',
        path: './audio/debate/hwork/hwork_speech102-06.mp3',
    },
    {
        id: 'hwork_speech102-07',
        path: './audio/debate/hwork/hwork_speech102-07.mp3',
    },
    {
        id: 'hwork_speech102-08',
        path: './audio/debate/hwork/hwork_speech102-08.mp3',
    },
    {
        id: 'hwork_speech102-09',
        path: './audio/debate/hwork/hwork_speech102-09.mp3',
    },
    {
        id: 'hwork_speech102-10',
        path: './audio/debate/hwork/hwork_speech102-10.mp3',
    },
    {
        id: 'hwork_speech102-11',
        path: './audio/debate/hwork/hwork_speech102-11.mp3',
    },
    {
        id: 'hwork_speech102-12',
        path: './audio/debate/hwork/hwork_speech102-12.mp3',
    },
    {
        id: 'hwork_speech102-13',
        path: './audio/debate/hwork/hwork_speech102-13.mp3',
    },
    {
        id: 'hwork_speech102-14',
        path: './audio/debate/hwork/hwork_speech102-14.mp3',
    },
    {
        id: 'hwork_speech102-15',
        path: './audio/debate/hwork/hwork_speech102-15.mp3',
    },
    {
        id: 'hwork_speech102-16',
        path: './audio/debate/hwork/hwork_speech102-16.mp3',
    },
    {
        id: 'hwork_speech102-17',
        path: './audio/debate/hwork/hwork_speech102-17.mp3',
    },
    {
        id: 'hwork_speech102-18',
        path: './audio/debate/hwork/hwork_speech102-18.mp3',
    },
    {
        id: 'hwork_speech102-19',
        path: './audio/debate/hwork/hwork_speech102-19.mp3',
    },
    {
        id: 'hwork_speech102-20',
        path: './audio/debate/hwork/hwork_speech102-20.mp3',
    },
    {
        id: 'hwork_speech102-21',
        path: './audio/debate/hwork/hwork_speech102-21.mp3',
    },
    {
        id: 'hwork_speech102-22',
        path: './audio/debate/hwork/hwork_speech102-22.mp3',
    },
];

export const leisureAudio = [
    {
        id: 'leisure_speech100-01',
        path: './audio/debate/leisure/leisure_speech100-01.mp3',
    },
    {
        id: 'leisure_speech100-02',
        path: './audio/debate/leisure/leisure_speech100-02.mp3',
    },
    {
        id: 'leisure_speech100-03',
        path: './audio/debate/leisure/leisure_speech100-03.mp3',
    },
    {
        id: 'leisure_speech100-04',
        path: './audio/debate/leisure/leisure_speech100-04.mp3',
    },
    {
        id: 'leisure_speech100-05',
        path: './audio/debate/leisure/leisure_speech100-05.mp3',
    },
    {
        id: 'leisure_speech100-06',
        path: './audio/debate/leisure/leisure_speech100-06.mp3',
    },
    {
        id: 'leisure_speech100-07',
        path: './audio/debate/leisure/leisure_speech100-07.mp3',
    },
    {
        id: 'leisure_speech100-08',
        path: './audio/debate/leisure/leisure_speech100-08.mp3',
    },
    {
        id: 'leisure_speech100-09',
        path: './audio/debate/leisure/leisure_speech100-09.mp3',
    },
    {
        id: 'leisure_speech100-10',
        path: './audio/debate/leisure/leisure_speech100-10.mp3',
    },
    {
        id: 'leisure_speech100-11',
        path: './audio/debate/leisure/leisure_speech100-11.mp3',
    },
    {
        id: 'leisure_speech100-12',
        path: './audio/debate/leisure/leisure_speech100-12.mp3',
    },
    {
        id: 'leisure_speech100-13',
        path: './audio/debate/leisure/leisure_speech100-13.mp3',
    },
    {
        id: 'leisure_speech100-14',
        path: './audio/debate/leisure/leisure_speech100-14.mp3',
    },
    {
        id: 'leisure_speech100-15',
        path: './audio/debate/leisure/leisure_speech100-15.mp3',
    },
    {
        id: 'leisure_speech100-16',
        path: './audio/debate/leisure/leisure_speech100-16.mp3',
    },
    {
        id: 'leisure_speech100-17',
        path: './audio/debate/leisure/leisure_speech100-17.mp3',
    },
    {
        id: 'leisure_speech100-18',
        path: './audio/debate/leisure/leisure_speech100-18.mp3',
    },
    {
        id: 'leisure_speech100-19',
        path: './audio/debate/leisure/leisure_speech100-19.mp3',
    },
    {
        id: 'leisure_speech100-20',
        path: './audio/debate/leisure/leisure_speech100-20.mp3',
    },
];

export const prisonAudio = [
    {
        id: 'prison_speech300-01',
        path: './audio/debate/prison/prison_speech300-01.mp3',
    },
    {
        id: 'prison_speech300-02',
        path: './audio/debate/prison/prison_speech300-02.mp3',
    },
    {
        id: 'prison_speech300-03',
        path: './audio/debate/prison/prison_speech300-03.mp3',
    },
    {
        id: 'prison_speech300-04',
        path: './audio/debate/prison/prison_speech300-04.mp3',
    },
    {
        id: 'prison_speech300-05',
        path: './audio/debate/prison/prison_speech300-05.mp3',
    },
    {
        id: 'prison_speech300-06',
        path: './audio/debate/prison/prison_speech300-06.mp3',
    },
    {
        id: 'prison_speech300-07',
        path: './audio/debate/prison/prison_speech300-07.mp3',
    },
    {
        id: 'prison_speech300-08',
        path: './audio/debate/prison/prison_speech300-08.mp3',
    },
    {
        id: 'prison_speech300-09',
        path: './audio/debate/prison/prison_speech300-09.mp3',
    },
    {
        id: 'prison_speech300-10',
        path: './audio/debate/prison/prison_speech300-10.mp3',
    },
    {
        id: 'prison_speech300-11',
        path: './audio/debate/prison/prison_speech300-11.mp3',
    },
    {
        id: 'prison_speech300-12',
        path: './audio/debate/prison/prison_speech300-12.mp3',
    },
    {
        id: 'prison_speech300-13',
        path: './audio/debate/prison/prison_speech300-13.mp3',
    },
    {
        id: 'prison_speech300-14',
        path: './audio/debate/prison/prison_speech300-14.mp3',
    },
    {
        id: 'prison_speech300-15',
        path: './audio/debate/prison/prison_speech300-15.mp3',
    },
    {
        id: 'prison_speech300-16',
        path: './audio/debate/prison/prison_speech300-16.mp3',
    },
    {
        id: 'prison_speech300-17',
        path: './audio/debate/prison/prison_speech300-17.mp3',
    },
    {
        id: 'prison_speech300-18',
        path: './audio/debate/prison/prison_speech300-18.mp3',
    },
    {
        id: 'prison_speech300-19',
        path: './audio/debate/prison/prison_speech300-19.mp3',
    },
    {
        id: 'prison_speech300-20',
        path: './audio/debate/prison/prison_speech300-20.mp3',
    },
    {
        id: 'prison_speech300-21',
        path: './audio/debate/prison/prison_speech300-21.mp3',
    },
    {
        id: 'prison_speech300-22',
        path: './audio/debate/prison/prison_speech300-22.mp3',
    },
    {
        id: 'prison_speech300-23',
        path: './audio/debate/prison/prison_speech300-23.mp3',
    },
    {
        id: 'prison_speech300-24',
        path: './audio/debate/prison/prison_speech300-24.mp3',
    },
    {
        id: 'prison_speech300-25',
        path: './audio/debate/prison/prison_speech300-25.mp3',
    },
    {
        id: 'prison_speech300-26',
        path: './audio/debate/prison/prison_speech300-26.mp3',
    },
    {
        id: 'prison_speech300-27',
        path: './audio/debate/prison/prison_speech300-27.mp3',
    },
    {
        id: 'prison_speech300-28',
        path: './audio/debate/prison/prison_speech300-28.mp3',
    },
    {
        id: 'prison_speech300-29',
        path: './audio/debate/prison/prison_speech300-29.mp3',
    },
    {
        id: 'prison_speech300-30',
        path: './audio/debate/prison/prison_speech300-30.mp3',
    },
];

export const violentAudio = [
    {
        id: 'violent_speech202-01',
        path: './audio/debate/violent/violent_speech202-01.mp3',
    },
    {
        id: 'violent_speech202-02',
        path: './audio/debate/violent/violent_speech202-02.mp3',
    },
    {
        id: 'violent_speech202-03',
        path: './audio/debate/violent/violent_speech202-03.mp3',
    },
    {
        id: 'violent_speech202-04',
        path: './audio/debate/violent/violent_speech202-04.mp3',
    },
    {
        id: 'violent_speech202-05',
        path: './audio/debate/violent/violent_speech202-05.mp3',
    },
    {
        id: 'violent_speech202-06',
        path: './audio/debate/violent/violent_speech202-06.mp3',
    },
    {
        id: 'violent_speech202-07',
        path: './audio/debate/violent/violent_speech202-07.mp3',
    },
    {
        id: 'violent_speech202-08',
        path: './audio/debate/violent/violent_speech202-08.mp3',
    },
    {
        id: 'violent_speech202-09',
        path: './audio/debate/violent/violent_speech202-09.mp3',
    },
    {
        id: 'violent_speech202-10',
        path: './audio/debate/violent/violent_speech202-10.mp3',
    },
    {
        id: 'violent_speech202-11',
        path: './audio/debate/violent/violent_speech202-11.mp3',
    },
    {
        id: 'violent_speech202-12',
        path: './audio/debate/violent/violent_speech202-12.mp3',
    },
    {
        id: 'violent_speech202-13',
        path: './audio/debate/violent/violent_speech202-13.mp3',
    },
    {
        id: 'violent_speech202-14',
        path: './audio/debate/violent/violent_speech202-14.mp3',
    },
    {
        id: 'violent_speech202-15',
        path: './audio/debate/violent/violent_speech202-15.mp3',
    },
    {
        id: 'violent_speech202-16',
        path: './audio/debate/violent/violent_speech202-16.mp3',
    },
    {
        id: 'violent_speech202-17',
        path: './audio/debate/violent/violent_speech202-17.mp3',
    },
    {
        id: 'violent_speech202-18',
        path: './audio/debate/violent/violent_speech202-18.mp3',
    },
    {
        id: 'violent_speech202-19',
        path: './audio/debate/violent/violent_speech202-19.mp3',
    },
    {
        id: 'violent_speech202-20',
        path: './audio/debate/violent/violent_speech202-20.mp3',
    },
    {
        id: 'violent_speech202-21',
        path: './audio/debate/violent/violent_speech202-21.mp3',
    },
    {
        id: 'violent_speech202-22',
        path: './audio/debate/violent/violent_speech202-22.mp3',
    },
    {
        id: 'violent_speech202-23',
        path: './audio/debate/violent/violent_speech202-23.mp3',
    },
    {
        id: 'violent_speech202-24',
        path: './audio/debate/violent/violent_speech202-24.mp3',
    },
    {
        id: 'violent_speech202-25',
        path: './audio/debate/violent/violent_speech202-25.mp3',
    },
    {
        id: 'violent_speech202-26',
        path: './audio/debate/violent/violent_speech202-26.mp3',
    },
];

export const voteAudio = [
    {
        id: 'vote_speech302-01',
        path: './audio/debate/vote/vote_speech302-01.mp3',
    },
    {
        id: 'vote_speech302-02',
        path: './audio/debate/vote/vote_speech302-02.mp3',
    },
    {
        id: 'vote_speech302-03',
        path: './audio/debate/vote/vote_speech302-03.mp3',
    },
    {
        id: 'vote_speech302-04',
        path: './audio/debate/vote/vote_speech302-04.mp3',
    },
    {
        id: 'vote_speech302-05',
        path: './audio/debate/vote/vote_speech302-05.mp3',
    },
    {
        id: 'vote_speech302-06',
        path: './audio/debate/vote/vote_speech302-06.mp3',
    },
    {
        id: 'vote_speech302-07',
        path: './audio/debate/vote/vote_speech302-07.mp3',
    },
    {
        id: 'vote_speech302-08',
        path: './audio/debate/vote/vote_speech302-08.mp3',
    },
    {
        id: 'vote_speech302-09',
        path: './audio/debate/vote/vote_speech302-09.mp3',
    },
    {
        id: 'vote_speech302-10',
        path: './audio/debate/vote/vote_speech302-10.mp3',
    },
    {
        id: 'vote_speech302-11',
        path: './audio/debate/vote/vote_speech302-11.mp3',
    },
    {
        id: 'vote_speech302-12',
        path: './audio/debate/vote/vote_speech302-12.mp3',
    },
    {
        id: 'vote_speech302-13',
        path: './audio/debate/vote/vote_speech302-13.mp3',
    },
    {
        id: 'vote_speech302-14',
        path: './audio/debate/vote/vote_speech302-14.mp3',
    },
    {
        id: 'vote_speech302-15',
        path: './audio/debate/vote/vote_speech302-15.mp3',
    },
    {
        id: 'vote_speech302-16',
        path: './audio/debate/vote/vote_speech302-16.mp3',
    },
    {
        id: 'vote_speech302-17',
        path: './audio/debate/vote/vote_speech302-17.mp3',
    },
    {
        id: 'vote_speech302-18',
        path: './audio/debate/vote/vote_speech302-18.mp3',
    },
    {
        id: 'vote_speech302-19',
        path: './audio/debate/vote/vote_speech302-19.mp3',
    },
    {
        id: 'vote_speech302-20',
        path: './audio/debate/vote/vote_speech302-20.mp3',
    },
    {
        id: 'vote_speech302-21',
        path: './audio/debate/vote/vote_speech302-21.mp3',
    },
    {
        id: 'vote_speech302-22',
        path: './audio/debate/vote/vote_speech302-22.mp3',
    },
    {
        id: 'vote_speech302-23',
        path: './audio/debate/vote/vote_speech302-23.mp3',
    },
    {
        id: 'vote_speech302-24',
        path: './audio/debate/vote/vote_speech302-24.mp3',
    },
    {
        id: 'vote_speech302-25',
        path: './audio/debate/vote/vote_speech302-25.mp3',
    },
    {
        id: 'vote_speech302-26',
        path: './audio/debate/vote/vote_speech302-26.mp3',
    },
    {
        id: 'vote_speech302-27',
        path: './audio/debate/vote/vote_speech302-27.mp3',
    },
    {
        id: 'vote_speech302-28',
        path: './audio/debate/vote/vote_speech302-28.mp3',
    },
    {
        id: 'vote_speech302-29',
        path: './audio/debate/vote/vote_speech302-29.mp3',
    },
    {
        id: 'vote_speech302-30',
        path: './audio/debate/vote/vote_speech302-30.mp3',
    },
    {
        id: 'vote_speech302-31',
        path: './audio/debate/vote/vote_speech302-31.mp3',
    },
];

export const govtCallAudio = [
    {
        id: 'govt_feedback-01',
        path: './audio/phone_call/govt_feedback-01.mp3',
    },
    {
        id: 'govt_feedback-02',
        path: './audio/phone_call/govt_feedback-02.mp3',
    },
    {
        id: 'govt_feedback-03',
        path: './audio/phone_call/govt_feedback-03.mp3',
    },
    {
        id: 'govt_press-01',
        path: './audio/phone_call/govt_press-01.mp3',
    },
    {
        id: 'govt_question-01',
        path: './audio/phone_call/govt_question-01.mp3',
    },
    {
        id: 'govt_question-02',
        path: './audio/phone_call/govt_question-02.mp3',
    },
    {
        id: 'govt_question-03',
        path: './audio/phone_call/govt_question-03.mp3',
    },
    {
        id: 'govt_question-04',
        path: './audio/phone_call/govt_question-04.mp3',
    },
    {
        id: 'govt_question-05',
        path: './audio/phone_call/govt_question-05.mp3',
    },
    {
        id: 'govt_question-06',
        path: './audio/phone_call/govt_question-06.mp3',
    },
    {
        id: 'govt_question-07',
        path: './audio/phone_call/govt_question-07.mp3',
    },
    {
        id: 'govt_question-08',
        path: './audio/phone_call/govt_question-08.mp3',
    },
    {
        id: 'govt_question-09',
        path: './audio/phone_call/govt_question-09.mp3',
    },
    {
        id: 'govt_question-10',
        path: './audio/phone_call/govt_question-10.mp3',
    },
    {
        id: 'govt_question-11',
        path: './audio/phone_call/govt_question-11.mp3',
    },
    {
        id: 'govt_question-12',
        path: './audio/phone_call/govt_question-12.mp3',
    },
    {
        id: 'govt_vote-01',
        path: './audio/phone_call/govt_vote-01.mp3',
    },
    {
        id: 'govt_vote-02',
        path: './audio/phone_call/govt_vote-02.mp3',
    },
    {
        id: 'govt_vote-03',
        path: './audio/phone_call/govt_vote-03.mp3',
    },
    {
        id: 'govt_vote-04',
        path: './audio/phone_call/govt_vote-04.mp3',
    },
    {
        id: 'govt_vote-05',
        path: './audio/phone_call/govt_vote-05.mp3',
    },
    {
        id: 'govt_vote-06',
        path: './audio/phone_call/govt_vote-06.mp3',
    },
    {
        id: 'govt_vote-07',
        path: './audio/phone_call/govt_vote-07.mp3',
    },
    {
        id: 'govt_vote-08',
        path: './audio/phone_call/govt_vote-08.mp3',
    },
    {
        id: 'govt_vote-09',
        path: './audio/phone_call/govt_vote-09.mp3',
    },
    {
        id: 'govt_vote-10',
        path: './audio/phone_call/govt_vote-10.mp3',
    },
    {
        id: 'govt_vote-11',
        path: './audio/phone_call/govt_vote-11.mp3',
    },
    {
        id: 'govt_vote-12',
        path: './audio/phone_call/govt_vote-12.mp3',
    },
    {
        id: 'govt_vote-13',
        path: './audio/phone_call/govt_vote-13.mp3',
    },
    {
        id: 'govt_vote-14',
        path: './audio/phone_call/govt_vote-14.mp3',
    },
    {
        id: 'govt_vote-15',
        path: './audio/phone_call/govt_vote-15.mp3',
    },
    {
        id: 'three_line_whip_gov',
        path: './audio/phone_call/three_line_whip_gov.mp3',
    },
];
export const oppCallAudio = [
    {
        id: 'opp_feedback-01',
        path: './audio/phone_call/opp_feedback-01.mp3',
    },
    {
        id: 'opp_feedback-02',
        path: './audio/phone_call/opp_feedback-02.mp3',
    },
    {
        id: 'opp_feedback-03',
        path: './audio/phone_call/opp_feedback-03.mp3',
    },
    {
        id: 'opp_press-01',
        path: './audio/phone_call/opp_press-01.mp3',
    },
    {
        id: 'opp_question-01',
        path: './audio/phone_call/opp_question-01.mp3',
    },
    {
        id: 'opp_question-01a',
        path: './audio/phone_call/opp_question-01a.mp3',
    },
    {
        id: 'opp_question-02',
        path: './audio/phone_call/opp_question-02.mp3',
    },
    {
        id: 'opp_question-02a',
        path: './audio/phone_call/opp_question-02a.mp3',
    },
    {
        id: 'opp_question-03',
        path: './audio/phone_call/opp_question-03.mp3',
    },
    {
        id: 'opp_question-03a',
        path: './audio/phone_call/opp_question-03a.mp3',
    },
    {
        id: 'opp_question-04',
        path: './audio/phone_call/opp_question-04.mp3',
    },
    {
        id: 'opp_question-04a',
        path: './audio/phone_call/opp_question-04a.mp3',
    },
    {
        id: 'opp_question-05',
        path: './audio/phone_call/opp_question-05.mp3',
    },
    {
        id: 'opp_question-05a',
        path: './audio/phone_call/opp_question-05a.mp3',
    },
    {
        id: 'opp_question-06',
        path: './audio/phone_call/opp_question-06.mp3',
    },
    {
        id: 'opp_question-06a',
        path: './audio/phone_call/opp_question-06a.mp3',
    },
    {
        id: 'opp_question-07',
        path: './audio/phone_call/opp_question-07.mp3',
    },
    {
        id: 'opp_question-07a',
        path: './audio/phone_call/opp_question-07a.mp3',
    },
    {
        id: 'opp_question-08',
        path: './audio/phone_call/opp_question-08.mp3',
    },
    {
        id: 'opp_question-09',
        path: './audio/phone_call/opp_question-09.mp3',
    },
    {
        id: 'opp_question-10',
        path: './audio/phone_call/opp_question-10.mp3',
    },
    {
        id: 'opp_question-11',
        path: './audio/phone_call/opp_question-11.mp3',
    },
    {
        id: 'opp_question-12',
        path: './audio/phone_call/opp_question-12.mp3',
    },
    {
        id: 'opp_vote-01',
        path: './audio/phone_call/opp_vote-01.mp3',
    },
    {
        id: 'opp_vote-02',
        path: './audio/phone_call/opp_vote-02.mp3',
    },
    {
        id: 'opp_vote-03',
        path: './audio/phone_call/opp_vote-03.mp3',
    },
    {
        id: 'opp_vote-04',
        path: './audio/phone_call/opp_vote-04.mp3',
    },
    {
        id: 'opp_vote-05',
        path: './audio/phone_call/opp_vote-05.mp3',
    },
    {
        id: 'opp_vote-06',
        path: './audio/phone_call/opp_vote-06.mp3',
    },
    {
        id: 'opp_vote-07',
        path: './audio/phone_call/opp_vote-07.mp3',
    },
    {
        id: 'opp_vote-08',
        path: './audio/phone_call/opp_vote-08.mp3',
    },
    {
        id: 'opp_vote-09',
        path: './audio/phone_call/opp_vote-09.mp3',
    },
    {
        id: 'opp_vote-10',
        path: './audio/phone_call/opp_vote-10.mp3',
    },
    {
        id: 'opp_vote-11',
        path: './audio/phone_call/opp_vote-11.mp3',
    },
    {
        id: 'opp_vote-12',
        path: './audio/phone_call/opp_vote-12.mp3',
    },
    {
        id: 'opp_vote-13',
        path: './audio/phone_call/opp_vote-13.mp3',
    },
    {
        id: 'opp_vote-14',
        path: './audio/phone_call/opp_vote-14.mp3',
    },
    {
        id: 'opp_vote-15',
        path: './audio/phone_call/opp_vote-15.mp3',
    },
    {
        id: 'three_line_whip_opp',
        path: './audio/phone_call/three_line_whip_opp.mp3',
    },
];

export const allAudio = [
    ...aidAudio,
    ...climateAudio,
    ...fieldsAudio,
    ...fuelAudio,
    ...genericAudio,
    ...homeworkAudio,
    ...leisureAudio,
    ...prisonAudio,
    ...violentAudio,
    ...voteAudio,
    ...govtCallAudio,
    ...oppCallAudio,
];
